module.exports = __webpack_public_path__ + "static/media/blck22.7419ef51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black/blck22.jpg
// module id = 486
// module chunks = 0